import React from "react";
import { Atom } from "react-loading-indicators";
import "./Loading.scss";
import { useTheme } from "@emotion/react";

export function Loading({ loadingText }) {
	const theme = useTheme();
	return (
		<>
			<div
				className="page"
				style={{ backgroundColor: theme.palette.background.default }}
			>
				<div className="loading">
					<Atom
						color="#c10000"
						size="large"
						text={loadingText}
						textColor=""
					/>
				</div>
			</div>
		</>
	);
}
